import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ClientesListLayer from '../components/ClientesListLayer';
import ProdutosListLayer from '../components/ProdutosListLayer';

const ProdutosListPage = () => {
    const [searchParams] = useSearchParams();
    const { data, mutate } = useFetch(`/produto`, { params: { ...Object.fromEntries([...searchParams]) } });
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Produtos" icon="solar:box-outline" />

            {/* UsersListLayer */}
            <ProdutosListLayer data={data} mutate={mutate} />
        </>
    );
};

export default ProdutosListPage;
